import {Component, inject, Input, OnInit} from "@angular/core";
import {TemplateService} from "../../template.service";
import {C1BillResult, SubmissionData} from "../../../shipper";
import {
	NgbAccordionModule,
	NgbActiveModal,
	NgbNav,
	NgbNavContent,
	NgbNavItem,
	NgbNavLink,
	NgbNavOutlet
} from "@ng-bootstrap/ng-bootstrap";
import {AsyncPipe, DatePipe, NgIf} from "@angular/common";
import {async, Observable} from "rxjs";
import {IsfViewSpinnerService} from "./isf.view.spinner";
import {IsfTransmissionComponent} from "../transmission/isf.transmission.component";
import {ISFSubmissionStatus} from "../isf.submission.status";
import {IsfBillStatusAccordion} from "../isf.bill.status.accordion";
import {C1BillResultView} from "../../c1/c1.bill.result";


@Component({
	selector: 'isf-vew',
	standalone: true,
	imports: [
		//JsonPipe,
		NgbNav,
		NgbNavOutlet,
		NgbNavContent,
		NgbNavItem,
		NgbNavLink,
		NgIf,
		AsyncPipe,
		IsfTransmissionComponent,
		DatePipe,
		NgbAccordionModule,
		ISFSubmissionStatus,
		IsfBillStatusAccordion,
		C1BillResultView
	
	],
	template: `

        <div id="spinner" *ngIf="spinner.visibility | async" class="spinner">
            <div class="lds-ripple"><div></div><div></div></div>
        </div>
		
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
				
				
                <div class="modal-header bg-dark">
                    <button type="button" class="btn-close text-bg-info" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                
				
                <div class="modal-body" *ngIf="isfData | async as isf">
					
                    <ul ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false" >
						
                        <li ngbNavItem id="dash">
                            <a ngbNavLink>ISF</a>
                            <ng-template ngbNavContent class="tab-content">

								
								<div class="container-fluid">
									<div class="row">
										<div class="col-lg-6 col-sm-12">
                                            <table class="table table-sm table-bordered">
                                                <thead>
                                                <tr>
                                                    <th class="w-50">Status</th>
                                                    <th>Transaction No</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td><isf-status [status]="isf.status"></isf-status></td>
                                                    <td>ISF:# {{isf.transactionNumber}}</td>
                                                </tr>
                                                </tbody>
                                                <thead>
													<tr>
														<th>Submitted At</th>
														<th>Confirmation</th>
													</tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>{{isf.submittedAt | date:'medium'}}</td>
                                                    <td>
                                                        <button class="btn btn-outline-danger text-danger" (click)="getPdf()" [disabled]="pdfDisabled(isf)">
                                                            <i class="fa fa-file-pdf-o"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
											
										</div>
										<div class="col-lg-6 col-sm-12">
                                            <table class="table table-sm table-bordered">
                                                <thead>
                                                <tr>
                                                    <th class="w-50">Vessel</th>
                                                    <th>ETD</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>{{isf.vessel}}</td>
                                                    <td>{{isf.etd}}</td>
                                                </tr>
                                                </tbody>
                                                <thead>
                                                <tr>
                                                    <th>Desc</th>
                                                    <th>Origin</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>{{isf.description}}</td>
                                                    <td>{{isf.originCountry}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
										</div>
									</div>
								</div>
								
                                
								<bill-status-accordion [bills]="isf.bills"></bill-status-accordion>
								
                            </ng-template>

                        </li>

                        <li ngbNavItem id="list">
                            <a ngbNavLink>Transmission</a>
                            <ng-template ngbNavContent>
                                <isf-transmission [isf]="isf"></isf-transmission>
                            </ng-template>
                        </li>

                        <li ngbNavItem id="query">
                            <a ngbNavLink>C1 Result</a>
                            <ng-template ngbNavContent>

                                <c1-bill-result-view [billResult]="billResult"></c1-bill-result-view>
								
                            </ng-template>
                        </li>

                    </ul>

                    <div [ngbNavOutlet]="nav" class="mt-2"></div>
					
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" (click)="modal.dismiss('Close')">Close</button>
                </div>
            </div>
        </div>
	`,
	styles:[`
	
		.accordion-button:not(.collapsed){
			background-color: #36393e
		}


        .accordion-button{
			font-size: 14px;
		}
		
		.mr-2{
			margin-right: 20px;
		}
	`]
})
export class IsfVew implements OnInit{
 
	service:TemplateService = inject(TemplateService);
	modal:NgbActiveModal = inject(NgbActiveModal);
	spinner:IsfViewSpinnerService = inject(IsfViewSpinnerService);
	
	@Input()
	id!:number;
	
	// @ts-ignore
	isfData:Observable<SubmissionData> = null;
	
	isf!:SubmissionData;
	
	
	billResult!:Observable<C1BillResult[]>;
	
	testId = 43737;
	//43842
	
	
	/**
	 *
	 * @param service
	 */
	constructor(service: TemplateService) {
		this.service = service;
	}
	
	
	
	ngOnInit(): void {
  
		//console.log(this.isf);
		
		this.isfData = this.service.getIsf(this.id);
		
		this.billResult = this.service.getQueryResult(this.id);
		
		
		/*
		this.service.getQueryResult(this.testId).subscribe((res) => {
			console.log(res);
		})
		
		 */
    }
	
	
	
	getPdf(){
		console.log("get pdf data...");
		
		this.service.pdfConfirmation(this.id).subscribe((data) => {
			const url = URL.createObjectURL(data);
			window.open(url,"_blank");
		});
	}
	
	
	pdfDisabled(isf:SubmissionData):boolean{
		return !['ACCEPTED','UPDATED'].includes(isf.status);
	}
	
	
	close(){
	
	}
	
}
